import { createContext } from 'react';

import type { ToastItem, ToastOptions } from './types';

export type ToastContextValue = {
  dismiss: (id?: string) => void;
  enqueue: (options: ToastOptions) => string;
  toasts: ToastItem[];
};

export const ToastContext = createContext<ToastContextValue | null>(null);
